import useStore from "core/custom-hooks/useStore";

import { openPopup } from "components/Popup/Popup";
import { ofirUrl } from "core/common/constants/env";
import * as Utils from "core/common/utils";
import { setPopup } from "core/store/actionCreators";
import { navigate } from "raviger";

const useInquiryManagement = () => {
    const { state, dispatch, authRepository } = useStore();
    const { business } = state;

    const action = async () => {
        //Utils.loadingWrapper(dispatch, async () => {
        const key = await authRepository.getOfirKey(business?.business_id);

        if (Utils.isSuccessfulRequest(dispatch, key?.data, true)) {
            if (key?.data?.data?.Token) {
                const url = `${ofirUrl}?customerId=${business?.business_id}&token=${key?.data?.data?.Token}`
                localStorage.setItem("link-ofir", url)
                navigate(`/ofir-site`)
            } else {
                openPopup(
                    dispatch,
                    "אינך מנוי לשירות זה",
                    "ניתן לפנות לשירות הלקוחות באמצעות צור קשר",
                    "סגירה",
                    () => dispatch(setPopup({ isOpen: false }))
                );
            }

        }
        //});
    };

    const condition = business && business.is_ppa;;

    return { action, condition }
};

export default useInquiryManagement;